import { get } from 'lodash';
import { setNoRouteAccess } from 'apps/user/actions/user';

export function excludeLoginLevel(loginLevel, shouldRedirect) {
  return (nextState, replace, path, extras) => {
    const { store } = extras;
    const { dispatch } = store;
    const { user } = store.getState();
    if (user.authenticationLevel !== loginLevel) { return true; }

    if (shouldRedirect) {
      const redirectUrl = get(nextState, 'location.query.redirect', '/');
      replace(redirectUrl);
      return false;
    }

    dispatch(setNoRouteAccess());
    return false;
  };
}
